module.exports = __webpack_public_path__ + "static/media/health.a2b20402.svg";